import { createContext } from "react"
import { type Tenant } from "../../common/hooks/useTenant"

// Definisikan interface untuk tipe data yang ingin Anda bagikan melalui context

// Buat context dengan menggunakan tipe data yang sesuai dengan interface yang Anda definisikan
export const TenantContext = createContext<Tenant | null | undefined>(undefined)
